// 热门车型上的广告
import React, { useEffect, useState, useRef } from 'react'

import { useCityName } from 'Components/hooks'
import { sendAdMonitor, sendTeaAdEvent } from 'lib/tea-analyze'

import Label from './label'
import { PopularSeriesAdResult, IPopularSeriesAd } from './interface'
import applyHttpsImage from 'lib/apply-https-img'

export function usePopularSeriesAd() {
  const [adInfo, setAdInfo] = useState<{
    [key: string]: IPopularSeriesAd
  }>({})
  const cityName = useCityName()
  // 获取数据
  useEffect(() => {
    if (typeof cityName !== 'undefined') {
      window
        .fetch(
          `/motor/ad/m/pc/car_series_fixed_position?city_name=${encodeURIComponent(
            cityName
          )}`,
          {
            credentials: 'include',
          }
        )
        .then(res => res.json())
        .then((data: PopularSeriesAdResult) => {
          if (data.data && data.data.length) {
            const result = data.data.reduce((acc, curr) => {
              return {
                ...acc,
                [curr.idx]: curr,
              }
            }, {})
            data.data.forEach(adData => {
              // 区分第一排
              adData.idx <= 7
                ? sendTeaAdEvent('ad_send_hot_series_hover_card', {
                  ad_material_id: adData.materiel_str,
                  ad_target_url: adData.web_url,
                  log_extra: adData.log_extra,
                  ad_id: adData.id_str,
                  ad_req_id: JSON.parse(adData.log_extra).req_id,
                  car_series_id: adData.series_id,
                  car_series_name: adData.series_name,
                })
                : sendTeaAdEvent('ad_send_home_text_hover', {
                  ad_material_id: adData.materiel_str,
                  ad_target_url: adData.web_url,
                  log_extra: adData.log_extra,
                  ad_id: adData.id_str,
                  ad_req_id: JSON.parse(adData.log_extra).req_id,
                  car_series_id: adData.series_id,
                  car_series_name: adData.series_name,
                  rank: String(adData.idx),
                })
            })
            setAdInfo(result)
          }
        })
    }
  }, [cityName])

  return adInfo
}
// export type IPopularSeriesAd = IPopularSeriesAd

export function PopularSeriesAd({
  data,
  show,
  onClick,
  index,
}: {
  data: IPopularSeriesAd
  show: boolean
  onClick(): void
  index: number
}) {
  const adShowRef = useRef<number>()
  const adData = {
    ad_material_id: data.materiel_str,
    ad_target_url: data.web_url,
    log_extra: data.log_extra,
    ad_id: data.id_str,
    ad_req_id: JSON.parse(data.log_extra).req_id,
    car_series_id: data.series_id,
    car_series_name: data.series_name,
    rank: String(data.idx),
  }
  useEffect(() => {
    // 2s内重复的hover不上报
    if (adShowRef.current) {
      return
    }
    if (show) {
      // 区分第一行和第三行
      const showStr =
        index === 0
          ? 'ad_show_hot_series_hover_card'
          : 'ad_show_home_text_hover'
      sendTeaAdEvent(showStr, adData)
      // 2s内重复的hover不上报
      adShowRef.current = window.setTimeout(() => {
        adShowRef.current = 0
      }, 2000)
      if (data.track_url_list) {
        data.track_url_list.forEach(url => {
          sendAdMonitor({
            url,
            requestId: data.ad_log_id,
            eventId: 'ad_show_hot_series_hover_card',
          })
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])
  if (!data || !show) return null
  return (
    <>
      <div
        className={`banner`}
        onClick={() => {
          onClick()
          window.open(data.web_url, '_blank')
        }}
      >
        <img src={applyHttpsImage(data.image.url)} />
        <Label text={data.label} />
        {/* 小三角箭头 */}
        <div className="arrow" />
      </div>
      <style jsx>
        {`
          .banner {
            position: absolute;
            left: -1px;
            bottom: 95%;
            width: 250px;
            height: 100px;
            padding: 5px;
            cursor: pointer;
            border: 1px solid #ededed;
            background: #fff;
            box-shadow: 0 2px 10px 0 rgba(31, 33, 41, 0.12);
            border-radius: 2px;
          }
          .arrow {
            display: inline-block;
            width: 8px;
            height: 8px;
            background: #fff;
            transform: rotate(45deg);
            position: absolute;
            bottom: -4px;
            left: 45px;
            box-shadow: 0 2px 10px 0 rgba(31, 33, 41, 0.12);
            border-top-left-radius: 8px;
          }
          .banner :global(span) {
            bottom: 10px;
            right: 10px;
          }
          img {
            vertical-align: middle;
            max-width: 100%;
            border-radius: 2px;
          }
        `}
      </style>
    </>
  )
}
